module.exports = __webpack_public_path__ + "img/crazy_extravagant.dfffeb49.jpg";